const periodicity = {
    Year: {
        value: 'Y',
        label: 'year'
    },
    Quarter: {
        value: 'Q',
        label: 'quarter'
    },
    Month: {
        value: 'M',
        label: 'month'
    },
    Week: {
        value: 'W',
        label: 'week'
    },
    Day: {
        value: 'D',
        label: 'day'
    }
}

export default periodicity
